export default __webpack_public_path__ + "static/media/backgroundjobmgr.1f3e7821.svg";